var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.688973 322.850036l459.034694 0c14.550391 35.815717 48.405453 59.881832 87.85493 59.881832 52.724829 0 95.466282-41.832757 95.466282-94.557586s-42.741453-96.504938-95.466282-96.504938c-38.83754 0-72.233138 23.732517-87.144756 55.45501L208.688973 247.124354c-20.035312 0-36.277228 16.771989-36.277228 37.862329C172.412768 306.078047 188.654684 322.850036 208.688973 322.850036z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M815.368332 698.40341 354.189811 698.40341c-14.887059-35.815717-48.230468-56.692187-87.005586-56.692187-52.639894 0-95.313809 42.62275-95.313809 95.332229s42.672892 95.28618 95.313809 95.28618c39.386032 0 73.187883-26.479071 87.714737-58.201563l460.46937 0c20.00359 0 36.2189-16.778128 36.2189-37.862329C851.587232 715.183586 835.370899 698.40341 815.368332 698.40341zM267.314185 767.647471c-16.844643 0-30.500665-13.673417-30.500665-30.540573 0-16.867156 13.656021-30.540573 30.500665-30.540573s30.500665 13.673417 30.500665 30.540573C297.81485 753.974054 284.158828 767.647471 267.314185 767.647471z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M208.688973 551.047318l214.641545 0c14.550391 31.722492 48.405453 58.06444 87.85493 58.06444s73.30454-26.341948 87.85493-58.06444L815.852356 551.047318c20.035312 0 36.277228-19.331277 36.277228-40.420595 0-21.090341-16.241916-40.420595-36.277228-40.420595L598.331227 470.206128c-14.910595-31.722492-48.307216-56.494689-87.144756-56.494689s-72.233138 24.772196-87.144756 56.494689L208.688973 470.206128c-20.035312 0-36.277228 19.330254-36.277228 40.420595C172.412768 531.717064 188.654684 551.047318 208.688973 551.047318z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilters);
export default __webpack_public_path__ + "static/media/iconFilters.0bc139b30f8118599ab46afa78813fad.svg";
export { ForwardRef as ReactComponent };